<template>
  <!-- Mensagem Agradecimento 02 style="background-image: url(&quot;@/assets/imagens/fundo_lago.jpg&quot;);" style="opacity : 0.5; -moz-opacity: 0.65; filter: alpha(opacity=65);"-->
  <div class=" py-5 section-aquamarine" id="agradecimento">
    <div class="container-fluid text-center">
      <div class="row align-items-center justify-content-center" style="height:15vh;">
        <div class="col-md-12">
          <h1 class="text-white">MENSAGEM DE AGRADECIMENTO</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 align-items-center">
          <img class="img-fluid"
               src="@/assets/imagens/logo_mensagem_agradecimento.png" width="80%" alt="Fundo Cover">
        </div>
        <div class="col-md-6 align-items-center">
          <img class="img-fluid"
               src="@/assets/imagens/logo_mensagem_agradecimento_texto.png" width="70%" alt="Fundo Cover">
        </div>
        <div class="col-md-12 align-items-center"> <!-- width:30%; -->
          <a class="btn btn-warning btn-lg rounded p-4"
             style="border-radius: 24px!important;"
             href="https://bit.ly/39uSWVB">Acesse Aqui!</a><!--&nbsp;Acesse o formulário clicando aqui!&nbsp;-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Bloco9Agradecimento"
}
</script>

<style scoped>

</style>